export const styles = {
  wrapper: {
    textAlign: 'center',
    flexDirection: 'column',
  },
  imageContainer: {
    position: 'relative',
    maxWidth: '784px',
    m: 'auto',
  },
  iconsWrapper: {
    mx: 'auto',
    gap: '40px',
    mt: 2,
  },
  icon: {
    gap: 2,
    fontWeight: 500,
  },
};
